import React, { useEffect } from 'react';
import { useScreenInit } from './useScreenInit';
import { initPixel } from './lib/pixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyDidntWork } from './components/WhyDidntWork';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useScreenInit();
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen selection:bg-[#C86B5E] selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <WhyDidntWork data-id="element-4" />
        <Mechanism data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <WhoFor data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <FAQ data-id="element-10" />
        <Offer data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}